export default defineNuxtPlugin(() => {
  // prekompajlirano (ne pravi se svaki poziv)
  const SRB_MAP: Record<string, string> = {
    'š': 's',
    'đ': 'dj',
    'ž': 'z',
    'č': 'c',
    'ć': 'c',
  }

  const SRB_RE = /[šđžčć]/gi
  const CLEAN_PRODUCT_RE = /[|\\\/,\.]/g
  const WS_RE = /\s+/g
  const DASH_RE = /-+/g
  const TRIM_DASH_START_RE = /^-+/
  const TRIM_DASH_END_RE = /-+$/
  const REMOVE_QS_RE = /[?=]/g

  const srbTolat = {
    name: 'srbTolat',

    srbTolat(title: string) {
      if (!title) return ''
      return String(title).replace(SRB_RE, (m) => SRB_MAP[m.toLowerCase()] ?? m)
                          .split(' ')
                          .join('-')
                          .toLowerCase()
    },

    srbTolatPath(title: string) {
      // "Cene teletine" -> "cene-teletine" (sa latinicom)
      const t = this.srbTolat(String(title ?? '').toLowerCase())
      return t.replace(WS_RE, '-')
              .split(',')
              .join('')
              .split('"')
              .join('')
    },

    slugify(text: string) {
      // tvoj stari slugify, samo optimizovan
      return String(text ?? '')
        .toLowerCase()
        .replace(REMOVE_QS_RE, '')
        .replace(WS_RE, '-')      // space -> -
        .replace(DASH_RE, '-')    // više crtica -> jedna
        .replace(TRIM_DASH_START_RE, '')
        .replace(TRIM_DASH_END_RE, '')
    },

    srbTolatPathProduct(title: string) {
      // uklanja | \ / , .
      const t = this.srbTolat(String(title ?? '').toLowerCase())
        .replace(CLEAN_PRODUCT_RE, '')
        .trim()
        .replace(WS_RE, ' ')
      return t.replace(WS_RE, '-')
    },

    srbTolatPathEmpty(title: string) {
      // sve bez razmaka
      const t = this.srbTolat(String(title ?? '').toLowerCase())
      return t.replace(WS_RE, '')
    },

    srbTolatPathSlugify(title: string) {
      // tvój stari: title.split('-').join('') pa srbTolat pa slugify
      const t = String(title ?? '').split('-').join('')
      return this.slugify(this.srbTolat(t))
    },
  }

  return {
    provide: {
      srbTolat,
    },
  }
})
